import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { api, apiError } from "@/lib/api";

const inputCls = "rounded-none bg-black/40 border-white/15 text-white";

export const ChangePasswordDialog = ({ open, onOpenChange }) => {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.post("/auth/change-password", { current_password: current, new_password: next });
      localStorage.setItem("staff_token", data.token);
      toast.success("Senha alterada");
      setCurrent("");
      setNext("");
      onOpenChange(false);
    } catch (err) { toast.error(apiError(err)); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#121314] border-white/10 text-white rounded-none max-w-sm" data-testid="change-password-dialog">
        <DialogHeader><DialogTitle className="dz-heading text-2xl uppercase font-black">Minha senha</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <Input required type="password" placeholder="Senha atual" value={current} onChange={(e) => setCurrent(e.target.value)} className={inputCls} data-testid="current-password-input" />
          <Input required type="password" minLength={8} placeholder="Nova senha (mín. 8)" value={next} onChange={(e) => setNext(e.target.value)} className={inputCls} data-testid="new-password-input" />
          <button type="submit" data-testid="change-password-submit" className="w-full py-2 bg-[#c81e1e] text-white dz-heading uppercase font-bold tracking-wider">Salvar</button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
